export default [
  {
    name: 'No',
    value: 0,
    class: 'info',
  },
  {
    name: 'Yes',
    value: 1,
    class: 'default',
  },
];
